module.exports = __webpack_public_path__ + "img/screen3.ecbd795e.png";